import { Dialog, Button, ExtendedTheme } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/styles';
import { useDialog } from '../../providers/DialogProvider';
import { DialogContent, DialogActions } from '@material-ui/core';

const useStyles = makeStyles((theme: ExtendedTheme) =>
  createStyles({
    modalBody: {
      padding: theme.spacing(0, 2, 2),
      [theme.breakpoints.up('sm')]: {
        width: 500
      }
    },
    buttonWrapper: {
      marginTop: theme.spacing(2),
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(1)
    }
  })
);

export const DialogContainer = () => {
  const classes = useStyles();
  const { isOpen, close, isClosing, dialogOptions } = useDialog();

  if (!dialogOptions) return <></>;

  return (
    <Dialog open={isOpen} title={dialogOptions.title} handleClose={() => close(false)}>
      <DialogContent className={classes.modalBody}>{dialogOptions.content}</DialogContent>
      <DialogActions className={classes.modalBody}>
        <div className={classes.buttonWrapper}>
          <Button colorType="grey" disabled={isClosing} onClick={() => close(false)}>
            {dialogOptions.cancelText || 'Cancel'}
          </Button>
          <Button disabled={isClosing} colorType={dialogOptions.okColorType || 'primary'} onClick={() => close(true)}>
            {dialogOptions.okText || 'OK'}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
